module.exports = __webpack_public_path__ + "static/media/insta-6.cf2f5e9d.png";